import React, { Component } from "react";

import {  Form,
  Input,
  DatePicker,
  Select,
  Modal,
  message,
  Checkbox,
  Upload,
  Button,
  Tabs,
  Row,
  Col,
  ColorPicker,
  Tooltip,
  Spin,
  Divider } from "antd";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";  
import { StoreContext } from "../store/RootStore";
import VehicleStore from "../store/VehicleSecuretrackStore";
import { observer } from "mobx-react";
import config from "../config";


import withRouter from "../withRouter";
const { Option } = Select;

class Superpath extends Component {
   formRef = React.createRef();
  
  constructor(props) {
      super(props);
       this.state = {
          companies: [],
          newCompany: "",
          selectedCompanyId: null,
          loadingSpin: false,
        };
       this.vehicleStore = new VehicleStore();
       
  }  
 
  onVehicleDetailsSubmit = async (values) => {
    this.setState({ loading: true });
    console.log(values);


    const vehicle = {
      ...values,
      tokenId: "",
      companyId: this.state.selectedCompanyId,
      id: this.state.vehicleId,
      platenoImage:this.state.platenoImage,
      simNoImage:this.state.simNoImage,
      imeiImage :this.state.imeiImage,
      isRelay: values?.isRelay ? 1 : 0,
      userId: 1,
      companies: this.state.companies,
      isSecurePath:1
    };
    console.log(vehicle);


    const data = { tokenId: "", vehicle: vehicle };

    const resp = await this.vehicleStore.addTechnicianData(data);

    await this.props.response(resp);
    
    this.setState({ loading: false });
  };
  closeModal = () => {
    this.props.closeModal();
  };
  
  async componentDidMount() {
    // Simulated DB data
    await this.vehicleStore.getTechnicianCompanies();

    const companies = this.vehicleStore.techniciancompanies;
    //console.log(companies)
    await this.setState({companies:companies})

    // const fetchedCompanies = [
    //   { id: "1", name: "Company A" },
    //   { id: "2", name: "Company B" },
    // ];

    // const selectedFromDB = 2; // Value to be preselected from DB

    this.setState({
      //companies: fetchedCompanies,
      //selectedCompanyId: selectedFromDB,
    });

    
    await this.setState({ loadList: 1 });

    const vehicleId = this.props.vehicleIdForEdit;
    ///console.log(vehicleId);
    
    if (vehicleId) {
      await this.filldata(vehicleId);
      this.setState({ vehicleId: vehicleId });
    }
  }

  filldata = async (vehicleId) => {
    //console.log("filldata",vehicleId)
    await this.setState({ loadingSpin: true });
    const getVehicleDetails = await this.vehicleStore.getTechnicianVehicleData(vehicleId);
   // console.log(getVehicleDetails)
    await this.formRef.current.setFieldsValue({
        companyId : getVehicleDetails.companyId,
        chassisNo: getVehicleDetails.chassisNo,
        vehicleName: getVehicleDetails.vehicleName,
        plateno: getVehicleDetails.vehicleNo,
        isRelay: getVehicleDetails.isRelay ? 1 : 0,
        
    })  
    await this.setState({ selectedCompanyId: getVehicleDetails.companyId,loadingSpin: false });
    await this.setState({ platenoImage: getVehicleDetails.platenoImage });
    await this.setState({ imeiImage: getVehicleDetails.imeiImage });
    await this.setState({ simNoImage: getVehicleDetails.simNoImage });

  }  
  getUploadData = async (fileUp) => {
      let fileinfo = fileUp.file.response;
  
      if (fileinfo?.success == "S") {
        // console.log(fileinfo.data)
  
        await this.setState({ icon: fileinfo.data });
      }
      fileUp.fileList[0].url = config.fleetURL + fileinfo?.folderName;
      this.vehicleStore.setLogoFromDb(fileUp.fileList);
  
      this.setState({ update: 1 });
    };
    getUploadData2 = async (fileUp) => {
      let fileinfo = fileUp.file.response;
  
      if (fileinfo?.success == "S") {
        // console.log(fileinfo.data)
  
        await this.setState({ platenoImage: fileinfo.data });
      }
      fileUp.fileList[0].url = config.fleetURL + fileinfo?.folderName;
      this.vehicleStore.setPlatenoImageFromDb(fileUp.fileList);
  
      this.setState({ update: 1 });
    };
    getUploadData3 = async (fileUp) => {
      let fileinfo = fileUp.file.response;
  
      if (fileinfo?.success == "S") {
        // console.log(fileinfo.data)
  
        await this.setState({ simNoImage: fileinfo.data });
      }
      fileUp.fileList[0].url = config.fleetURL + fileinfo?.folderName;
      this.vehicleStore.setSimNoImageFromDb(fileUp.fileList);
  
      this.setState({ update: 1 });
    };
    getUploadData4 = async (fileUp) => {
      let fileinfo = fileUp.file.response;
  
      if (fileinfo?.success == "S") {
        // console.log(fileinfo.data)
  
        await this.setState({ imeiImage: fileinfo.data });
      }
      fileUp.fileList[0].url = config.fleetURL + fileinfo?.folderName;
      this.vehicleStore.setImeiImageFromDb(fileUp.fileList);
  
      this.setState({ update: 1 });
    };

  handleChange = (value) => {
    this.setState({ selectedCompanyId: value });
  };

  handleInputChange = (e) => {
    this.setState({ newCompany: e.target.value });
  };

  addItem = () => {
    
    const { newCompany, companies } = this.state;
    if (!newCompany.trim()) return;

    const newId = `new-${Date.now()}`;
    const newEntry = { companyId: newId, name: newCompany };
    console.log(companies)
    console.log(newEntry)

    this.setState({
      companies: [...companies, newEntry],
      selectedCompanyId: newId,
      newCompany: "",
    });
  };

  render() {
    const { companies, selectedCompanyId, newCompany } = this.state;

    return (
       <>
              <div style={{ padding: 0 }}>
                <div>
                  <Spin spinning={this.state.loadingSpin} fullscreen>

                 
      <Form    ref={this.formRef}
                
                className="formClass" //change
                layout="vertical"
                onFinish={this.onVehicleDetailsSubmit}
                onFinishFailed={this.handleFormError}
                // {...this.layout}
                name="nest-message">
         <Row style={{ overflowY: "scroll", height: "480px" }}>
                      <Col span={12} className="formColumnClass">
                      

        <Form.Item
          label="Account"
          required
          style={{ maxWidth: 300 }}
        >
          <Select
            value={selectedCompanyId}
            onChange={this.handleChange}
            placeholder="Select or add company"
            dropdownRender={(menu) => (
              <>
                {menu}
                <Divider style={{ margin: "8px 0" }} />
                <div style={{ display: "flex", gap: 8, padding: 8 }}>
                  <Input
                    placeholder="New company"
                    value={newCompany}
                    onChange={this.handleInputChange}
                    onPressEnter={this.addItem}
                  />
                  <Button type="link" onClick={this.addItem}>
                    Add
                  </Button>
                </div>
              </>
            )}
          >
            
            {companies.map((item) => (
                  <Option key={item.companyId} value={item.companyId}>
                    {item.name}
                  </Option>
                ))}
          </Select>
        </Form.Item>
        <Form.Item
                                  name="plateno"
                                  label={this.context.translate("_PLATE_NO_")}
                                  rules={[{ required: true }]}
                                >
                                  <Input   />
                                </Form.Item>   
                                <Form.Item
                                                          name="vehicleName"
                                                          // label="Asset Name/Alias"
                                                          label={this.context.translate(
                                                            "_FLEET_VEHICLE_VEHICLEDETAIL_VEHICLENAME_"
                                                          )}
                                                           rules={[{ required: true }]}
                                                        >
                                                          <Input  />
                                                        </Form.Item>
                                                        
                                                          <Form.Item
                                                            name="chassisNo"
                                                            label={this.context.translate("_CHASSIS_NUMBER_")}
                                                            rules={[{ required: true }]}
                                                          >
                                                            <Input  />
                                                          </Form.Item>
                                
                                                        
                                                       
                                <br/>
                                                                                 <Form.Item
                                                                                    name="isRelay"
                                                                                    // className="formCheckboxCss"
                                                                                    label=" "
                                                                                    valuePropName="checked"
                                                                                    // style={{ marginRight: '5px' }}
                                                                                  >
                                                                                    <Checkbox>
                                                                                      {this.context.translate("_RELAY_")}
                                                                                    </Checkbox>
                                                                                  </Form.Item>
                                
       </Col>
       <Col span={12} className="formColumnClass">
                               
                               
                              
       <br/>
                                   
       
                               <Upload
                                   style={{ marginTop: "15px" }}
                                   name="platenoImage"
                                   action={
                                     config.baseURL + "/index.php?c=company&a=fileupload"
                                   }
                                   listType="picture"
                                   data={{ fileType: "vehiclephoto", fieldName: "platenoImage" }}
                                   onChange={this.getUploadData2}
                                   onRemove={async () => {
                                     await this.setState({ platenoImage: "", fileList: [] });
                                     await this.vehicleStore.setPlatenoImageFromDb([]);
                                   }}
                                   maxCount={1}
                                   accept=".jpg,.png"
                                   // Add the beforeUpload prop to perform file extension validation
                                  // beforeUpload={(file) => this.validateFile(file)}
                                    {...this.vehicleStore.platenoImageFromDb}
                                >
                                   <Button className="imgupload" icon={<UploadOutlined />}>
                                     {this.context.translate("_UPLOAD_PLATENO_")}
                                   </Button>
                               </Upload>
       <br/>
                               <Upload
                                   style={{ marginTop: "15px" }}
                                   name="simNoImage"
                                   action={
                                     config.baseURL + "/index.php?c=company&a=fileupload"
                                   }
                                   listType="picture"
                                   data={{ fileType: "vehiclephoto", fieldName: "simNoImage" }}
                                   onChange={this.getUploadData3}
                                   onRemove={async () => {
                                     await this.setState({ simNoImage: "", fileList: [] });
                                     await this.vehicleStore.setSimNoImageFromDb([]);
                                   }}
                                   maxCount={1}
                                   accept=".jpg,.png"
                                   // Add the beforeUpload prop to perform file extension validation
                                  // beforeUpload={(file) => this.validateFile(file)}
                                    {...this.vehicleStore.simNoImageFromDb}
                                >
                                   <Button className="imgupload" icon={<UploadOutlined />}>
                                     {this.context.translate("_UPLOAD_SIM_IMAGE_")}
                                   </Button>
                               </Upload>
       
       
       
       
       <br/>
                                 <Upload
                                   style={{ marginTop: "15px" }}
                                   name="imeiImage"
                                   action={
                                     config.baseURL + "/index.php?c=company&a=fileupload"
                                   }
                                   listType="picture"
                                   data={{ fileType: "vehiclephoto", fieldName: "imeiImage" }}
                                   onChange={this.getUploadData4}
                                   onRemove={async () => {
                                     await this.setState({ imeiImage: "", fileList: [] });
                                     await this.vehicleStore.setImeiImageFromDb([]);
                                   }}
                                   maxCount={1}
                                   accept=".jpg,.png"
                                   // Add the beforeUpload prop to perform file extension validation
                                  // beforeUpload={(file) => this.validateFile(file)}
                                    {...this.vehicleStore.imeiImageFromDb}
                                >
                                   <Button className="imgupload" icon={<UploadOutlined />}>
                                     {this.context.translate("_UPLOAD_IMEI_IMAGE_")}
                                   </Button>
                               </Upload>
                               
                             </Col>
       
       </Row>
        <div className="formBtnGroup">
                      <Button
                        className="formCancelButton"
                        onClick={(e) => {
                          this.closeModal();
                          // this.formRef.current?.resetFields();
                        }}
                      >
                        {this.context.translate("_FLEET_CLOSE_BTN_")}
                      </Button>
                      <Button
                        type="primary"
                        className="formSaveButton"
                        htmlType="submit"
                      >
                        {/* Next */}
                        {this.context.translate("_ADD_")}
                      </Button>
                    </div>
      </Form>
       </Spin>
          </div>

         
        </div>
      </>
    );
  }
}
Superpath.contextType = StoreContext;
export default observer(withRouter(Superpath));